export default "__VITE_ASSET__f45fb0b8__"